import React, { useState } from 'react';
import { TimePicker, Space } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const AntdTimePicker = ({ 
  value, 
  onChange, 
  placeholder = "选择时间范围",
  className = "" 
}) => {
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  // 解析现有值
  React.useEffect(() => {
    if (value && value.includes('-')) {
      const [start, end] = value.split('-');
      if (start && end) {
        setStartTime(dayjs(start.trim(), 'HH:mm'));
        setEndTime(dayjs(end.trim(), 'HH:mm'));
      }
    } else {
      setStartTime(null);
      setEndTime(null);
    }
  }, [value]);

  const handleStartTimeChange = (time) => {
    setStartTime(time);
  };

  const handleEndTimeChange = (time) => {
    setEndTime(time);
  };

  // 自动生成时间范围
  React.useEffect(() => {
    if (startTime && endTime) {
      const timeRange = `${startTime.format('HH:mm')}-${endTime.format('HH:mm')}`;
      onChange(timeRange);
    } else if (!startTime && !endTime) {
      onChange('');
    }
  }, [startTime, endTime, onChange]);

  return (
    <div className={`antd-time-picker ${className}`}>
      <Space style={{ width: '100%' }} size="middle">
        <div style={{ flex: 1 }}>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            开始时间
          </label>
          <TimePicker
            value={startTime}
            onChange={handleStartTimeChange}
            format="HH:mm"
            placeholder="开始时间"
            style={{ width: '100%' }}
            suffixIcon={<ClockCircleOutlined />}
            size="large"
          />
        </div>
        
        <div style={{ flex: 1 }}>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            结束时间
          </label>
          <TimePicker
            value={endTime}
            onChange={handleEndTimeChange}
            format="HH:mm"
            placeholder="结束时间"
            style={{ width: '100%' }}
            suffixIcon={<ClockCircleOutlined />}
            size="large"
          />
        </div>
      </Space>
    </div>
  );
};

export default AntdTimePicker;
